import * as React from "react"
import { VisibilityContext } from "react-horizontal-scrolling-menu"
import { BiRightArrow } from "react-icons/bi"
import { Button } from "@chakra-ui/react"
import { Icon } from "../../../common/icons"
import useWindowSize from "../../../../hooks/useWindowSize"

export const RightArrow = ({ isLandscape }: { isLandscape?: boolean }) => {
  const { isLastItemVisible, scrollNext } = React.useContext(VisibilityContext)
  const { screenSize } = useWindowSize()

  return (
    <Button
      justifyContent="center"
      position="absolute"
      alignItems="center"
      background={"transperent"}
      right={screenSize.width < 350 ? "0px" : "-25px"}
      bottom={isLandscape ? "0.8rem" : "1.5rem"}
      minW="unset"
      color="black"
      padding={0}
      zIndex={100000}
      visibility={isLastItemVisible ? "hidden" : "visible"}
      disabled={isLastItemVisible}
      _focus={{}}
      _hover={{}}
      _active={{}}
      onClick={() => scrollNext()}
    >
      <Icon src={BiRightArrow} />
    </Button>
  )
}
